import Vue from "vue";
import { OnvifCam as Cam } from "@/utils/onvif/OnvifCam";
import { CAMERA_MODEL } from "@/config/const";

export function onvifInitControl(vm, url, cameraId) {
  const onvifUrl = url.replace(/^https?:\/\//, "").replace(/\/$/, "");
  const onvifHostName =
    onvifUrl.split(":").length > 1 ? onvifUrl.split(":")[0] : onvifUrl;
  const onvifPort =
    onvifUrl.split(":").length > 1 ? onvifUrl.split(":")[1] : 443;

  vm.onvifBaseParameter = {
    hostname: onvifHostName,
    username: vm.camera.onvifUserName,
    password: vm.camera.onvifPassword,
    port: onvifPort,
    timeout: 5000,
  };
  Vue.$log.debug(
    `###  onvifBaseParameter(${vm.camera.id})`,
    vm.onvifBaseParameter
  );

  // onvif接続可能か、さらにptz操作可能かを確認。
  new Cam(vm.onvifBaseParameter, function CamFunc(err) {
    const key = `onvifAuthErrorNotified_${cameraId}`;
    if (err) {
      Vue.$log.debug("カメラにONVIF接続できませんでした。", err);
      if (!sessionStorage.getItem(key)) {
        vm.$vs.notify({
          color: "danger",
          title:
            "ONVIFの権限を取得できませんでした。権限がない場合は管理者にお問い合わせください。",
        });
        sessionStorage.setItem(key, "1");
      }
      return;
    }
    if (this.capabilities.PTZ === undefined) {
      Vue.$log.debug("カメラはPTZ操作をサポートしていません。");
      return;
    }
    if (!vm.camera.isOnvifControl) {
      Vue.$log.debug("ONVIF制御の権限がございません。");
      return;
    }

    let onvifApi = this;
    onvifApi.getDeviceInformation(function(err, res) {
      let model;
      if (res.model === CAMERA_MODEL.properties[CAMERA_MODEL.HV_PTZ500].model) {
        model = CAMERA_MODEL.HV_PTZ500;
      } else if (
        res.model === CAMERA_MODEL.properties[CAMERA_MODEL.WV_S6530].model
      ) {
        model = CAMERA_MODEL.WV_S6530;
      } else if (
        res.model === CAMERA_MODEL.properties[CAMERA_MODEL.HV_PTZ501].model
      ) {
        model = CAMERA_MODEL.HV_PTZ501;
      } else {
        model = CAMERA_MODEL.OTHERS;
      }
      vm.cameraModel = res.model;
      vm.cameraSmallMove = CAMERA_MODEL.properties[model].smallMove;
      vm.cameraLargeMove = CAMERA_MODEL.properties[model].largeMove;
      vm.cameraZoomMove = CAMERA_MODEL.properties[model].zoomMove;
    });

    Vue.$log.debug(
      "### カメラにONVIF接続しました。 this.capabilities",
      this.capabilities
    );
    sessionStorage.removeItem(key);
    vm.onvifEnable = true;
  });
}

export function onvifPtzByStep(
  vm,
  xDirection,
  yDirection,
  zoomDirection,
  movingAngle
) {
  const xStep = (xDirection * movingAngle) / 360;
  const yStep = (yDirection * movingAngle) / 90;
  const zoomStep = zoomDirection / 10;
  const onvifProfileToken = vm.camera.onvifProfileToken;

  new Cam(vm.onvifBaseParameter, function CamFunc(err) {
    if (err) {
      Vue.$log.error(err);
      return;
    }
    let onvifApi = this;
    onvifApi.relativeMove(
      {
        profileToken: onvifProfileToken,
        x: xStep,
        y: yStep,
        zoom: zoomStep,
      },
      function(err, responseData, rawXml) {
        // for debug.
        Vue.$log.debug("relativeMove[xml] = ", rawXml);
      }
    );
  });
}

export function onvifPtzByScroll(
  vm,
  xDirection,
  yDirection,
  zoomDirection,
  movingSecond
) {
  const speedRate = 0.5;
  const xSpeed = xDirection * speedRate;
  const ySpeed = yDirection * speedRate;
  const zoomSpeed = zoomDirection * speedRate;
  const onvifProfileToken = vm.camera.onvifProfileToken;

  // for debug.
  Vue.$log.debug(
    "onvifPtzByScroll() values = ",
    onvifProfileToken,
    xSpeed,
    ySpeed,
    zoomSpeed,
    movingSecond
  );

  if (vm.onvifMovingStopTimer) {
    clearTimeout(vm.onvifMovingStopTimer);
  }

  new Cam(vm.onvifBaseParameter, function CamFunc(err) {
    if (err) {
      Vue.$log.error(err);
      return;
    }
    let onvifApi = this;
    let apiTimeout = movingSecond * 1000;
    if (
      vm.cameraModel === CAMERA_MODEL.properties[CAMERA_MODEL.HV_PTZ501].model
    ) {
      apiTimeout = apiTimeout * 4;
    }
    onvifApi.continuousMove(
      {
        profileToken: onvifProfileToken,
        x: xSpeed,
        y: ySpeed,
        zoom: zoomSpeed,
        timeout: apiTimeout,
      },
      function(err, responseData, rawXml) {
        // for debug.
        Vue.$log.debug("continuousMove[xml] = ", rawXml);
      }
    );
  });

  if (
    vm.cameraModel === CAMERA_MODEL.properties[CAMERA_MODEL.HV_PTZ500].model ||
    vm.cameraModel === CAMERA_MODEL.properties[CAMERA_MODEL.HV_PTZ501].model
  ) {
    vm.onvifMovingStopTimer = setTimeout(
      () => onvifStopScroll(vm),
      movingSecond * 1000
    );
  }
}

export function onvifStopScroll(vm) {
  const onvifProfileToken = vm.camera.onvifProfileToken;
  new Cam(vm.onvifBaseParameter, function CamFunc(err) {
    if (err) {
      Vue.$log.error(err);
      return;
    }
    let onvifApi = this;
    onvifApi.stop(
      {
        profileToken: onvifProfileToken,
        panTilt: true,
        zoom: true,
      },
      function(err, responseData, rawXml) {
        Vue.$log.debug("stop[xml] = ", rawXml);
      }
    );
  });
}

export function onvifGotoHomePosition(vm) {
  const onvifProfileToken = vm.camera.onvifProfileToken;
  new Cam(vm.onvifBaseParameter, function CamFunc(err) {
    if (err) {
      Vue.$log.error(err);
      return;
    }
    let onvifApi = this;
    onvifApi.gotoHomePosition(
      {
        profileToken: onvifProfileToken,
      },
      function(err, responseData, rawXml) {
        Vue.$log.debug("gotoHomePosition[xml] = ", rawXml);
      }
    );
  });
}

export function onvifSetHomePosition(vm) {
  const onvifProfileToken = vm.camera.onvifProfileToken;
  new Cam(vm.onvifBaseParameter, function CamFunc(err) {
    if (err) {
      Vue.$log.error(err);
      return;
    }
    let onvifApi = this;
    onvifApi.setHomePosition(
      {
        profileToken: onvifProfileToken,
      },
      function(err, responseData, rawXml) {
        Vue.$log.debug("setHomePosition[xml] = ", rawXml);
      }
    );
  });
}

export function onvifSetHomePositionConfirm(vm) {
  vm.$vs.dialog({
    type: "confirm",
    color: "danger",
    title: "映像ホーム位置の設定",
    text: "現座標をホーム位置として設定しますか？",
    acceptText: "セットする",
    cancelText: "キャンセル",
    accept: () => onvifSetHomePosition(vm),
  });
}

export function onvifReboot(vm) {
  new Cam(vm.onvifBaseParameter, function CamFunc(err) {
    if (err) {
      Vue.$log.error(err);
      return;
    }
    let onvifApi = this;
    onvifApi.systemReboot(function(err, responseData, rawXml) {
      Vue.$log.debug("systemReboot[xml] = ", rawXml);
    });
  });
}

/**
 * (おまけ)[onvif]解像度の変更.
 */
export function onvifUpdateResolution(vm) {
  const onvifProfileToken = vm.camera.onvifProfileToken;
  new Cam(vm.onvifBaseParameter, function CamFunc(err) {
    if (err) {
      Vue.$log.error(err);
      return;
    }
    let targetProfile = this.profiles.find(
      profile => profile.$.token === onvifProfileToken
    );
    let targetConfig = targetProfile.videoEncoderConfiguration;
    targetConfig.useCount = 1; // onvif_node-module内部で使っているので、指定が必要.
    targetConfig.H264.profile = targetConfig.H264.H264Profile; // onvif_node-module内部で使っているので、指定が必要.

    // // 解像度：低、フレームレート:デフォルト
    targetConfig.resolution = { width: 320, height: 240 };
    targetConfig.rateControl = {
      frameRateLimit: 25,
      encodingInterval: 1,
      bitrateLimit: 2147483647,
    };

    // 解像度：中、フレームレート:中
    // targetConfig.resolution = {width: 640, height: 480};
    // targetConfig.rateControl= {frameRateLimit: 15,  encodingInterval: 1, bitrateLimit: 1000};

    // // 解像度：デフォルト、フレームレート:低   // ※ SIMの速度、もしくは、ffmpegの変換サイクルに耐えられないので、非現実的。
    // targetConfig.resolution = {width: 1920, height: 1080};
    // targetConfig.rateControl= {frameRateLimit: 5,  encodingInterval: 1, bitrateLimit: 500};

    let onvifApi = this;
    onvifApi.setVideoEncoderConfiguration(targetConfig, function(
      err,
      responseData
    ) {
      // for debug
      Vue.$log.debug("setVideoEncoderConfiguration = ", responseData);
    });
  });
}
